import axios from 'axios';
import {
  Steps,
  Form,
  Input,
  Radio,
  Row,
  Col,
  Checkbox,
  Button,
  message,
  Spin,
} from 'antd';
import { ErrorText, FieldWrapper, useCreateForm } from '@ecom-zform/react';

import { useCallback, useState } from 'react';


const { Step } = Steps;

const UVVusNirForm = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [loading, setLoading] = useState(false);

  const form = useCreateForm({
    formCore1: {
      first_name: '',
      work_email: '',
      phone: '',
      last_name: '',
      affiliation: '',
      country: '',
    },
    formCore2: {
      sample_num: '',
      sample_info: {
        sample_properties: [],
        sample_description: '',
      },
    },
    formCore3: {
      analytical_req: {
        analytical_program_selection: [],
        purpose_of_analytical_test: '',
        if_need_to_ship_after_test_samples_back: 'false',
        if_need_universallab_report: 'false',
        other_requirement: ''
      }
    },
  });

  const handleNext = useCallback(() => {
    if (currentStep === 0) {
      setCurrentStep(currentStep => currentStep + 1);
    }
    if (currentStep === 1) {
      form.n('formCore1').validateValue()
        .then(res => {
          setCurrentStep(currentStep => currentStep + 1);
        })
        .catch(err => {
          console.log("validateValue", err);
        })
    }
    if (currentStep === 2) {
      form.n('formCore2').validateValue()
        .then(res => {
          setCurrentStep(currentStep => currentStep + 1);
        })
        .catch(err => {
          console.log("validateValue", err);
        })
    }
    if (currentStep === 3) {
      form.n('formCore3').validateValue()
        .then(res => {
          const params1 = form.n('formCore1').state.value;
          const params2 = JSON.stringify({
            ...form.n('formCore2').n('sample_info').state.value,
            sample_properties: form.n('formCore2').n('sample_info').nodeArray('sample_properties').state.value.join(','),
          });
          const params3 = JSON.stringify({
            ...form.n('formCore3').n('analytical_req').state.value,
            analytical_program_selection: form.n('formCore3').n('analytical_req').nodeArray('analytical_program_selection').state.value.join(',')
          });
          setLoading(true);
          axios(
            {
              method: 'post',
              url: 'https://eu.edditen.cc/api/place_order',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {
                ...params1,
                sample_num: Number(form.n('formCore2').n('sample_num').state.value),
                sample_info: params2,
                analytical_req: params3,
                test_service: 'uv-vis-nir'
              }
            })
            .then(res => {
              console.log("res", res);
              message.success('提交成功');
              setCurrentStep(0);
              form.reset();
              window.location.href = 'https://www.universallab.org/reply.html';
            })
            .catch(err => {
              message.error('提交失败');
              console.log("rerr", err);
            })
            .finally(() => {
              setLoading(false);
            })
        })
        .catch(err => {
          console.log("validateValue", err);
        })
    }
  }, [currentStep]);

  // todo 1 property value
  const sampleOptions = [
    { label: 'Soild', value: 'Soild' },
    { label: 'Powder', value: 'Powder' },
    { label: 'Thin film', value: 'Thin_film' },
    { label: 'Liquid', value: 'Liquid' },
    { label: 'Fiber', value: 'Fiber' },
    { label: 'Magnetic', value: 'Magnetic' },
    { label: 'Fragile', value: 'Fragile' },
    { label: 'Easily oxidixed', value: 'Easily_oxidixed' },
    { label: 'Loose', value: 'Loose' },
    { label: 'Electron sensitive', value: 'Electron_sensitive' },
    { label: 'Ultra hard', value: 'Ultra_hard' },
    { label: 'Toxic', value: 'Toxic' },
    { label: 'Volatile', value: 'Volatile' },
    { label: 'Absorbent', value: 'Absorbent' },
  ];

  const anyOptions = [
    {
      label: 'Liquid sample absorbance measurement (50 CHF/sample)',
      value: 'Liquid-sample-absorbance-measurement-(50-CHF/sample)',
    },
    {
      label: 'Liquid sample transmittance measurement (50 CHF/sample)',
      value: 'Liquid-sample-transmittance-measurement-(50-CHF/sample)',
    },
    {
      label: 'Powder sample absorbance measurement (50 CHF/sample)',
      value: 'Powder-sample-absorbance-measurement-(50-CHF/sample)',
    },
    {
      label: 'Powder sample reflection measurement (50 CHF/sample)',
      value: 'Powder-sample-reflection-measurement-(50-CHF/sample)',
    },
    {
      label: 'Bulk sample absorbance measurement (50 CHF/sample)',
      value: 'Bulk-sample-absorbance-measurement-(50-CHF/sample)',
    },
    {
      label: 'Bulk sample reflection measurement (50 CHF/sample)',
      value: 'Bulk-sample-reflection-measurement-(50-CHF/sample)',
    },
    {
      label: 'Thin film sample absorbance measurement (50 CHF/sample)',
      value: 'Thin-film-sample-absorbance-measurement-(50-CHF/sample)',
    },
    {
      label: ' Thin film sample reflection measurement (50 CHF/sample)',
      value: '-Thin-film-sample-reflection-measurement-(50-CHF/sample)',
    },
    {
      label: 'Thin film sample transmittance measurement (50 CHF/sample)',
      value: 'Thin-film-sample-transmittance-measurement-(50-CHF/sample)',
    },
  ];

  return (
    <Spin spinning={loading}>
      <Steps size="small" current={currentStep}>
        <Step title="Notice" />
        <Step title="Contact information" />
        <Step title="Sample information" />
        <Step title="Analytical Requirement" />
      </Steps>
      {
        currentStep === 0 ? (
          <div>
            <h2>notce:</h2>
            <div style={{ marginBottom: 16 }}>Please provide us with the necessary information to evaluate your analytical needs</div>
            <div style={{ marginBottom: 16 }}>The listed price is just a reference for ordinary samples and analytical requirement</div>
            <div style={{ marginBottom: 16 }}>Customized offers can be provided for extraordinary samples and requirement</div>
            <div style={{ marginBottom: 16 }}>A definite offer will be given after we review the submitted order</div>
          </div>
        ) : null
      }
      {
        currentStep === 1 ? (
          <div>
            <h2>Cantact information</h2>
            <Form layout="vertical">
              {/* First name */}
              <Form.Item label="First name" required>
                <FieldWrapper
                  form={form.n('formCore1').n('first_name')}
                  rules={[{ required: true, message: 'Please input your first name!' }]}
                >
                  <Input placeholder='Please input your first name' />
                </FieldWrapper>
                <ErrorText form={form.n('formCore1').n('first_name')} />
              </Form.Item>
              {/* Last name */}
              <Form.Item label="Last name" required>
                <FieldWrapper
                  form={form.n('formCore1').n('last_name')}
                  rules={[{ required: true, message: 'Please input your Last name!' }]}
                >
                  <Input placeholder='Please input your last name' />
                </FieldWrapper>
                <ErrorText form={form.n('formCore1').n('last_name')} />
              </Form.Item>
              {/* Work email */}
              <Form.Item label="Work email" required>
                <FieldWrapper
                  form={form.n('formCore1').n('work_email')}
                  rules={[{ required: true, message: 'Please input your work email!' }]}
                >
                  <Input placeholder='Please input your work email' />
                </FieldWrapper>
                <ErrorText form={form.n('formCore1').n('work_email')} />
              </Form.Item>
              {/* phone */}
              <Form.Item label="Phone" required>
                <FieldWrapper
                  form={form.n('formCore1').n('phone')}
                  rules={[{ required: true, message: 'Please input your phone!' }]}
                >
                  <Input placeholder='Please input your phone' />
                </FieldWrapper>
                <ErrorText form={form.n('formCore1').n('phone')} />
              </Form.Item>
              {/* affiliation */}
              <Form.Item label="Affiliation" required>
                <FieldWrapper
                  form={form.n('formCore1').n('affiliation')}
                  rules={[{ required: true, message: 'Please input your affiliation!' }]}
                >
                  <Input placeholder='Please input your affiliation' />
                </FieldWrapper>
                <ErrorText form={form.n('formCore1').n('affiliation')} />
              </Form.Item>
              {/* country */}
              <Form.Item label="Country" required>
                <FieldWrapper
                  form={form.n('formCore1').n('country')}
                  rules={[{ required: true, message: 'Please input your country!' }]}
                >
                  <Input placeholder='Please input your country' />
                </FieldWrapper>
                <ErrorText form={form.n('formCore1').n('country')} />
              </Form.Item>
            </Form>
          </div>
        ) : null
      }
      {
        currentStep === 2 ? (
          <div>
            <h2>Sample information</h2>
            <Form layout="vertical">
              {/* sample_num */}
              <Form.Item label="Number of Sample">
                <FieldWrapper
                  form={form.n('formCore2').n('sample_num')}
                  rules={[{ required: true, message: 'Please input your sample num!' }]}
                >
                  <Input placeholder='Please input your sample num' />
                </FieldWrapper>
                <ErrorText form={form.n('formCore2').n('sample_num')} />
              </Form.Item>
              {/* sample_num */}
              <Form.Item label="Sample properties" required>
                <FieldWrapper
                  form={form.n('formCore2').n('sample_info').nodeArray('sample_properties')}
                  rules={[{ required: true, message: 'Please select your sample properties!' }]}
                >
                  <Checkbox.Group>
                    <Row>
                      {
                        sampleOptions.map(item => (
                          <Col span={6}>
                            <Checkbox value={item.value}>{item.label}</Checkbox>
                          </Col>
                        ))
                      }
                    </Row>
                  </Checkbox.Group>
                </FieldWrapper>
                <ErrorText form={form.n('formCore2').n('sample_num')} />
              </Form.Item>
              {/* sample_num */}
              <Form.Item label="Sample description" required>
                <FieldWrapper
                  form={form.n('formCore2').n('sample_info').n('sample_description')}
                  rules={[{ required: true, message: 'Please input your sample sample_description!' }]}
                >
                  <Input.TextArea placeholder='Please input your sample sample_description' />
                </FieldWrapper>
                <ErrorText form={form.n('formCore2').n('sample_info').n('sample_description')} />
              </Form.Item>
            </Form>
          </div>
        ) : null
      }
      {
        currentStep === 3 ? (
          <div>
            <h2>Analytical requirement</h2>
            <Form layout="vertical">
              {/* sample_num */}
              <Form.Item label="Analytical program selection" required>
                <FieldWrapper
                  form={form.n('formCore3').n('analytical_req').nodeArray('analytical_program_selection')}
                  rules={[{ required: true, message: 'Please checked your analytical program selection!' }]}
                >
                  <Checkbox.Group>
                    <Row>
                      {
                        anyOptions.map(item => (
                          <Col span={24}>
                            <Checkbox value={item.value}>{item.label}</Checkbox>
                          </Col>
                        ))
                      }
                    </Row>
                  </Checkbox.Group>

                  {/* <Checkbox.Group>
                    <Checkbox value="Elemctrochemical_Deposition_Sample_Protection（100CHF/sample）">Elemctrochemical Deposition Sample Protection（100CHF/sample）</Checkbox>
                  </Checkbox.Group> */}
                </FieldWrapper>
                <ErrorText form={form.n('formCore3').n('analytical_req').nodeArray('analytical_program_selection')} />
              </Form.Item>

              <Form.Item label="Purpose of analytical test">
                <FieldWrapper
                  form={form.n('formCore3').n('analytical_req').n('purpose_of_analytical_test')}
                >
                  <Input placeholder='Please input your first Purpose of analytical test' />
                </FieldWrapper>
              </Form.Item>

              <Form.Item label="If need to ship after test samples back" required>
                <FieldWrapper
                  form={form.n('formCore3').n('analytical_req').n('if_need_to_ship_after_test_samples_back')}
                >
                  <Radio.Group>
                    <Radio value='true'>Yes （50CHF/batch）</Radio>
                    <Radio value='false'>No</Radio>
                  </Radio.Group>
                </FieldWrapper>
                <ErrorText form={form.n('formCore3').n('analytical_req').n('if_need_to_ship_after_test_samples_back')} />
              </Form.Item>

              <Form.Item label="if need universallab report" required>
                <FieldWrapper
                  form={form.n('formCore3').n('analytical_req').n('if_need_universallab_report')}
                >
                  <Radio.Group>
                    <Radio value='true'>Yes （50CHF/sample）</Radio>
                    <Radio value='false'>No</Radio>
                  </Radio.Group>
                </FieldWrapper>
                <ErrorText form={form.n('formCore3').n('analytical_req').n('if_need_universallab_report')} />
              </Form.Item>

              <Form.Item label="Other requirement">
                <FieldWrapper
                  form={form.n('formCore3').n('analytical_req').n('other_requirement')}
                >
                  <Input.TextArea placeholder='Please input your sample other requirement' />
                </FieldWrapper>
              </Form.Item>
            </Form>
          </div>
        ) : null
      }
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        {
          currentStep !== 0 ? (
            <Button type="default" onClick={() => setCurrentStep(currentStep => currentStep - 1)}>Back</Button>
          ) : null
        }
        <Button
          type="primary"
          onClick={handleNext}
        >
          {
            currentStep !== 3 ? 'Next' : 'Finish'
          }
        </Button>
      </div>
    </Spin>
  );
};

export default UVVusNirForm;